import request from '@/utils/request';
/* 获取积分-积分商品列表 */
export function queryIntegralGoodsPageList(data) {
  return request({
    url: '/integral/goods/queryIntegralGoodsPageList',
    method: 'POST',
    data
  });
}
/* 增加积分 */
export function saveIntegralGoods(data) {
  return request({
    url: '/integral/goods/saveIntegralGoods',
    method: 'POST',
    data
  });
}
/* 修改积分 */
export function updateIntegralGoods(data) {
  return request({
    url: '/integral/goods/updateIntegralGoods',
    method: 'POST',
    data
  });
}
/* 积分商品明细 */
export function fetchIntegralGoodsDetailById(data) {
  return request({
    url: '/integral/goods/fetchIntegralGoodsDetailById',
    method: 'POST',
    data
  });
}
/* 删除积分 */
export function removeIntegralGoodsById(data) {
  return request({
    url: '/integral/goods/removeIntegralGoodsById',
    method: 'POST',
    data
  });
}
/* 上架或下架积分商品 */
export function enableIntegralGoodsById(data) {
  return request({
    url: '/integral/goods/enableIntegralGoodsById',
    method: 'POST',
    data
  });
}
/* 查询所有上架的商品列表 */
export function queryAllEnableGoodsList(data) {
  return request({
    url: '/integral/goods/queryAllEnableGoodsList',
    method: 'POST',
    data
  });
}
/* 积分配置-新增或修改积分配置 */
export function saveOrUpdateIntegralConfig(data) {
  return request({
    url: '/shop/config/saveOrUpdateShopConfig',
    method: 'POST',
    data
  });
}
/* 积分配置-获取积分配置信息 */
export function fetchIntegralConfigDetail(data) {
  return request({
    url: '/shop/config/fetchShopConfigDetail',
    method: 'POST',
    data
  });
}
/* 额外签到积分-列表数据 */
export function queryIntegralExtraPageList(data) {
  return request({
    url: '/integral/extra/queryIntegralExtraPageList',
    method: 'POST',
    data
  });
}
/* 额外签到积分-新增 */
export function saveIntegralExtra(data) {
  return request({
    url: '/integral/extra/saveIntegralExtra',
    method: 'POST',
    data
  });
}
/* 额外签到积分-修改 */
export function updateIntegralExtra(data) {
  return request({
    url: '/integral/extra/updateIntegralExtra',
    method: 'POST',
    data
  });
}
/* 额外签到积分-修改明细数据 */
export function fetchIntegralExtraDetailById(data) {
  return request({
    url: '/integral/extra/fetchIntegralExtraDetailById',
    method: 'POST',
    data
  });
}
/* 额外签到积分-删除 */
export function removeIntegralExtraById(data) {
  return request({
    url: '/integral/extra/removeIntegralExtraById',
    method: 'POST',
    data
  });
}
/* 额外签到积分-开启或关闭 */
export function enableIntegralExtraById(data) {
  return request({
    url: '/integral/extra/enableIntegralExtraById',
    method: 'POST',
    data
  });
}
/* 添加特殊积分弹窗-列表数据 */
export function queryIntegralSpecialPageList(data) {
  return request({
    url: '/integral/special/queryIntegralSpecialPageList',
    method: 'POST',
    data
  });
}
/* 添加特殊积分弹窗-新增 */
export function saveIntegralSpecial(data) {
  return request({
    url: '/integral/special/saveIntegralSpecial',
    method: 'POST',
    data
  });
}
/* 添加特殊积分弹窗-修改 */
export function updateIntegralSpecial(data) {
  return request({
    url: '/integral/special/updateIntegralSpecial',
    method: 'POST',
    data
  });
}
/* 添加特殊积分弹窗-修改明细数据 */
export function fetchIntegralSpecialDetailById(data) {
  return request({
    url: '/integral/special/fetchIntegralSpecialDetailById',
    method: 'POST',
    data
  });
}
/* 添加特殊积分弹窗-删除 */
export function removeIntegralSpecialById(data) {
  return request({
    url: '/integral/special/removeIntegralSpecialById',
    method: 'POST',
    data
  });
}
/* 添加特殊积分弹窗-开启或关闭 */
export function enableIntegralSpecialById(data) {
  return request({
    url: '/integral/special/enableIntegralSpecialById',
    method: 'POST',
    data
  });
}
/* 获取积分天数 */
export function getIntegralDays(data) {
  return request({
    url: '/integral/extra/getIntegralDays',
    method: 'POST',
    data
  });
}
/* 积分任务-积分任务列表 */
export function queryIntegralTaskPageList(data) {
  return request({
    url: '/integral/task/queryIntegralTaskPageList',
    method: 'POST',
    data
  });
}
/* 积分任务-删除 */
export function removeIntegralTaskById(data) {
  return request({
    url: '/integral/task/removeIntegralTaskById',
    method: 'POST',
    data
  });
}
/* 积分任务-开启或关闭 */
export function enableIntegralTaskById(data) {
  return request({
    url: '/integral/task/enableIntegralTaskById',
    method: 'POST',
    data
  });
}
/* 积分任务-新增 */
export function saveIntegralTask(data) {
  return request({
    url: '/integral/task/saveIntegralTask',
    method: 'POST',
    data
  });
}
/* 积分任务-编辑 */
export function updateIntegralTask(data) {
  return request({
    url: '/integral/task/updateIntegralTask',
    method: 'POST',
    data
  });
}
/* 积分任务-编辑明细 */
export function fetchIntegralTaskDetailById(data) {
  return request({
    url: '/integral/task/fetchIntegralTaskDetailById',
    method: 'POST',
    data
  });
}
/* 积分任务-题目管理- 题目列表 */
export function queryIntegralTaskQuestionPageList(data) {
  return request({
    url: '/integral/task/question/queryIntegralTaskQuestionPageList',
    method: 'POST',
    data
  });
}
/* 积分任务-题目管理- 删除 */
export function removeIntegralTaskQuestionById(data) {
  return request({
    url: '/integral/task/question/removeIntegralTaskQuestionById',
    method: 'POST',
    data
  });
}
/* 积分任务-题目管理- 开启或关闭 */
export function enableIntegralTaskQuestionById(data) {
  return request({
    url: '/integral/task/question/enableIntegralTaskQuestionById',
    method: 'POST',
    data
  });
}
/* 积分任务-题目管理- 新增 */
export function saveIntegralTaskQuestion(data) {
  return request({
    url: '/integral/task/question/saveIntegralTaskQuestion',
    method: 'POST',
    data
  });
}
/* 积分任务-题目管理- 修改 */
export function updateIntegralTaskQuestion(data) {
  return request({
    url: '/integral/task/question/updateIntegralTaskQuestion',
    method: 'POST',
    data
  });
}
/* 积分任务-题目管理- 题目明细 */
export function fetchIntegralTaskQuestionDetailById(data) {
  return request({
    url: '/integral/task/question/fetchIntegralTaskQuestionDetailById',
    method: 'POST',
    data
  });
}
/* 积分订单列表 */
export function queryWebIntegralOrderPageList(data) {
  return request({
    url: '/integral/goods/queryWebIntegralOrderPageList',
    method: 'POST',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/integral.js